import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const ShareCertificateRedirect = () => {
    const [searchParams , setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(()=>{
        if(searchParams?.get("ref")){
            navigate(`/verify/certificate/${searchParams?.get("ref")}` , {replace : true})
        }
    },[])
  return (
    <div>
      
    </div>
  )
}

export default ShareCertificateRedirect;
